/**
 * 物料下载
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { XInput, XOKButton, XCancelButton } from '@/components/xqxc_ui';
import TableList from './components/TableList';
import KeepAlive from '@/routes/KeepAlive';
import { SearchBox, SearchItem } from '@/components/Layout';
import { message } from 'antd';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

class Main extends React.Component {

    state = {
        name: '',
        orgList: [],
        tableSource: []
    }

    componentDidMount() {
        this.props.setBreadcrumbPaths(this.props.match);
        this._getData();
    }

    // 请求数据
    _getData = () => {
        const query = {
            paramCode: "OC_PLAT_MATERIAL"
        };
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.AdminParamMisService.getParamValueByCode&group=mis', query, 'POST').then((response) => {
            if (response.result) {
                const list = JSON.parse(response.result);
                this.setState({ tableSource: list, orgList: list });
            }
        }).catch((e) => {
            message.error(e.message);
        });
    }

    // 查询
    _searchHandle = () => {
        let list = this.state.orgList || [];
        list = list.filter((item) => {
            if (item.name.indexOf(this.state.name) >= 0) {
                return true;
            } else {
                return false;
            }
        });
        debugger;
        console.log(list);
        this.setState({ tableSource: list });
    }

    // 重置
    _resetHandle = () => {
        this.setState({ name: '' });
    }

    // 表格操作
    _tableAction = (type, item) => {
        if (type == 'download') {
            window.open(item.downUrl);
        }
    }

    render() {
        const { name, tableSource } = this.state;

        return (
            <div className={styles.flexBoxContainer}>
                <SearchBox>
                    <SearchItem>
                        <XInput
                            inputStyle={{ width: 200 }}
                            label='物料名称'
                            placeholder='请输入'
                            value={name}
                            bindThis={this}
                            bindName='name'
                        />
                    </SearchItem>
                    <SearchItem>
                        <XOKButton
                            style={{ marginLeft: '20px', width: '60px' }}
                            label='查询'
                            onClick={this._searchHandle}
                        />
                        <XCancelButton
                            style={{ marginLeft: '20px', width: '60px' }}
                            label='重置'
                            onClick={this._resetHandle}
                        />
                    </SearchItem>
                </SearchBox>
                <TableList
                    renderData={tableSource}
                    tableAction={this._tableAction}
                />
            </div>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    curTabID: PropTypes.string,
    setBreadcrumbPaths: PropTypes.func,
};

export default connect(null, { setBreadcrumbPaths })(Main);